import template from './llm-model-detail.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-llm-connect-llm-model-detail', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            item: null,
            providers: [],
            isLoading: false,
            isSaveSuccessful: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdlc_llm_model');
        },

        providerRepository() {
            return this.repositoryFactory.create('tdlc_llm_provider');
        },

        providerOptions() {
            return this.providers.map((provider) => ({
                value: provider.id,
                label: provider.prefix,
            }));
        },

        isNew() {
            return !this.$route.params.id;
        },

        pageTitle() {
            return this.isNew
                ? this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.titleCreate')
                : this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.titleEdit');
        },
    },

    created() {
        this.providerRepository.search(new Criteria()).then((result) => {
            this.providers = result;
        });

        if (this.isNew) {
            this.item = this.repository.create();
            this.item.active = true;
        } else {
            this.repository.get(this.$route.params.id).then((item) => {
                this.item = item;
            });
        }
    },

    methods: {
        onSave() {
            this.isLoading = true;
            this.repository.save(this.item).then(() => {
                this.isSaveSuccessful = true;
                this.createNotificationSuccess({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.saveSuccess'),
                });
                this.$router.push({ name: 'topdata.llm.connect.llm.model.list' });
            }).catch(() => {
                this.createNotificationError({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.saveError'),
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },

        onCancel() {
            this.$router.push({ name: 'topdata.llm.connect.llm.model.list' });
        },
    },
});
